import React from 'react';

import { useAppSelector } from '@pkg/hooks';

import { type CollectionChainType, SupportedTokens } from '@app/client';
import config from '@app/config';

import { ShareButton } from './ShareButton';
import { WishlistButton } from './WishlistButton';

import { ButtonGroup, Wrapper } from './styles';

interface CardBottomProps {
    contract?: string | null;
    token_id?: string | null;
    collection_slug?: string | null;
    isCollectionTile?: boolean;
    chain?: CollectionChainType;
}

export const CardBottom = ({ chain, contract, token_id, collection_slug, isCollectionTile }: CardBottomProps) => {
    const isRegisteredUser = useAppSelector((state) => state.user.isRegisteredUser);
    return (
        <Wrapper>
            <ButtonGroup></ButtonGroup>
            <ButtonGroup>
                {isRegisteredUser && (
                    <>
                        {!isCollectionTile && chain && (
                            <WishlistButton
                                chain={chain}
                                contract={contract || undefined}
                                token_id={token_id || undefined}
                            />
                        )}

                        {isCollectionTile && chain && (
                            <WishlistButton chain={chain} collection_slug={collection_slug || undefined} />
                        )}
                    </>
                )}
                {!isCollectionTile && contract && chain && token_id ? (
                    <ShareButton
                        shareUrl={`https://${config.publicUrl}/${SupportedTokens[chain]}/${contract}/${token_id}`}
                    />
                ) : null}
                {isCollectionTile && collection_slug && chain ? (
                    <ShareButton
                        shareUrl={`https://${config.publicUrl}/collection/${SupportedTokens[chain]}/${collection_slug}`}
                    />
                ) : null}
            </ButtonGroup>
        </Wrapper>
    );
};
